import {
  BsCheck,
  BsDash,
  BsExclamationTriangleFill,
  BsX,
  // BsXCircleFill,
} from "react-icons/bs";
import { FaRoute } from "react-icons/fa";
import { dedicatedOrderStatuses } from "./DedicatedDispatchConstants";
import { TooltipMouseTrack } from "../Utility/TooltipMouseTrack";

export const DedicatedOrderStatusIndicator = ({
  orderStatus,
  nextUp,
  missed,
  positionPreviouslySubmitted,
  size = 18,
  isModified,
}) => {
  //   console.log("position previously submitted", positionPreviouslySubmitted);
  return (
    <div className="tw-inline-block tw-pl-1">
      {(orderStatus === dedicatedOrderStatuses.unSubmitted &&
        positionPreviouslySubmitted) ||
      isModified ? (
        <TooltipMouseTrack message={isModified ? "Modified" : "Unsubmitted"}>
          <div
            style={{
              width: size,
              height: size,
              display: "grid",
              placeContent: "center",
            }}
          >
            <BsExclamationTriangleFill color={isModified ? "#ffca00" : "red"} />
          </div>
        </TooltipMouseTrack>
      ) : missed ? (
        <TooltipMouseTrack message="Not Complete">
          <div
            className="dispatch-board-order-status-indicator-container"
            style={{
              width: size,
              height: size,
              color: "red",
              backgroundColor: "red",
            }}
          >
            <BsX color="white" />
          </div>
        </TooltipMouseTrack>
      ) : orderStatus === dedicatedOrderStatuses.submitted ? (
        <TooltipMouseTrack message={nextUp ? "Next Up" : "Submitted"}>
          <div
            className={`${
              nextUp ? "" : "dispatch-board-order-status-indicator-container"
            }`}
            style={{
              width: size,
              height: size,
              color: nextUp ? "blue" : "green",
            }}
          >
            {nextUp ? <FaRoute style={{ marginTop: "-5px" }} /> : <BsDash />}
          </div>
        </TooltipMouseTrack>
      ) : orderStatus === dedicatedOrderStatuses.completed ? (
        <TooltipMouseTrack message="Completed">
          <div
            className="dispatch-board-order-status-indicator-container"
            style={{
              width: size,
              height: size,
              color: "green",
              backgroundColor: "green",
            }}
          >
            <BsCheck color="white" />
          </div>
        </TooltipMouseTrack>
      ) : (
        ""
      )}
    </div>
  );
};
